import React from 'react';
import { ArrowRightIcon, ZapIcon, PrinterIcon } from 'lucide-react';
import { PAYMENT_URL, COMPLETE_EDITION_COVER } from '../data/offer';
export function FinalCta() {
  return <section className="cube-grid border-t border-white/10 bg-navy-900" data-id="element-70" data-mp="19ez2ffcjrc38">
      <div className="mx-auto grid w-full max-w-5xl gap-8 px-4 py-16 sm:px-6 sm:py-20 lg:grid-cols-[0.8fr_1.2fr] lg:items-center lg:gap-12" data-id="element-71" data-mp="19cun81976qnn">
        <img src={COMPLETE_EDITION_COVER} alt="Cover of the Math Made Ready 2026 Complete Edition" className="mx-auto block w-full max-w-[240px] shadow-book ring-1 ring-white/10 lg:max-w-[300px]" data-id="element-72" data-mp="1jclhq2xrd5nq" />

        <div className="text-center lg:text-left" data-id="element-73" data-mp="1t2ev99hgnuum">
          <h2 className="text-2xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-74" data-mp="1o43nd4aq7uf1">
            Make the Next Math Session the Next Challenge They Want to
            Complete.
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-slate-300 sm:text-lg lg:mx-0" data-id="element-75" data-mp="1x51o9dpvblte">
            Give learners a clear challenge, give adults a ready-to-use
            resource, and make every practice session feel more rewarding.
          </p>

          <p className="mt-7 font-pixel text-3xl leading-none text-brand-gold sm:text-4xl" data-id="element-76" data-mp="s6iid31qgwid">
            $19 USD
          </p>

          <ul className="mt-5 flex flex-col items-center gap-3 text-sm text-slate-300 sm:flex-row sm:justify-center lg:justify-start" data-id="element-77" data-mp="123elsucrysg2">
            <li className="flex items-center gap-2 whitespace-nowrap" data-id="element-78" data-mp="163xd8nar9whq">
              <ZapIcon className="h-4 w-4 shrink-0 text-brand-cyan" aria-hidden="true" data-id="element-79" data-mp="1b2ruvlwzlf09" />
              Instant Digital Access
            </li>
            <li className="flex items-center gap-2 whitespace-nowrap" data-id="element-80" data-mp="1ktw92jeu8vu1">
              <PrinterIcon className="h-4 w-4 shrink-0 text-brand-cyan" aria-hidden="true" data-id="element-81" data-mp="1kv7gqubemnqf" />
              Printable for School and Home
            </li>
          </ul>

          <a href={PAYMENT_URL} className="group mt-8 inline-flex w-full items-center justify-center gap-2 border-b-4 border-[#b47a08] bg-brand-gold px-5 py-4 font-pixel text-[10px] uppercase leading-none tracking-[0.08em] text-navy-900 transition-[transform,background-color] duration-150 ease-out hover:bg-[#ffc23f] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-cyan active:translate-y-[2px] sm:w-auto sm:px-6 sm:text-xs" data-id="element-82" data-mp="3qufezt4b9qtq">
            Get Instant Access — $19 USD
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-83" data-mp="8gg199z4bxe5" />
          </a>
        </div>
      </div>
    </section>;
}